<script lang="ts" setup>
import {useDashboardStore} from '@/store';
import {useRouter} from 'vue-router';
import {useI18n} from 'vue-i18n';
import {computed} from 'vue';
import MultiViewLayout from 'src/components/layouts/MultiViewLayout.vue';
import NavItem from 'src/components/InPageNavItem.vue';

const dashboardStore = useDashboardStore(),
  router = useRouter(),
  {t} = useI18n();

const hasCommPrefsEnabled = computed(() => dashboardStore.patientConfig === null ? false : dashboardStore.patientConfig.features.isCommunicationPreferencesEnabled),
  isLoading = computed(() => dashboardStore.isLoading);

function onBackClick() {
  router.push({ name: 'Settings' });
}
</script>

<template>
  <q-page padding>
    <MultiViewLayout :loading="isLoading"
                     :onBackClick="onBackClick">

      <!-- Title -->
      <template #title>{{ t('settings') }}</template>

      <!-- Heading Text/Content -->
      <template #heading>{{ t('settings_legal_and_privacy') }}</template>

      <!-- View Unique Content -->
      <template #default>
        <zbm-skeleton-loader height="225px"
                             :loading="isLoading"
                             width="100%">
          
          <!-- Navigation -->
          <q-list>
            
            <!-- Safety Information -->
            <NavItem data-testid="safetyInformation"
                     :label="t('routine_safety')"
                     :to="{ name: 'Settings.SafetyInformation' }" />
  
            <!-- Privacy Policy -->
            <NavItem data-testid="privacyPolicy"
                     :label="t('activate_privacy_policy')"
                     :to="{ name: 'Settings.PrivacyPolicy' }" />
  
            <!-- Communication -->
            <NavItem v-if="hasCommPrefsEnabled"
                     data-testid="communicationPreferences"
                     :label="t('communication')"
                     :to="{ name: 'CommunicationPreferences', params: { interrupt: false } }" />
  
            <!-- EULA -->
            <NavItem data-testid="eula"
                     :label="t('settings_eula')"
                     :to="{ name: 'Settings.EULA' }" />
          </q-list>
        </zbm-skeleton-loader>
      </template>
    </MultiViewLayout>
  </q-page>
</template>